module.exports = __webpack_public_path__ + "img/wala.f4296523.svg";